import { gql } from "@apollo/client";

export const GET_SYSTEM_OPERATION_LOG_LISTING = gql`
    query GetSystemOperationLogListing(
        $filters: SystemOperationLogFiltersTypeInput
        $pageRequest: PageRequestTypeInput
    ) {
        getSystemOperationLogListing(filters: $filters, pageRequest: $pageRequest) {
            content {
                id
                bizType
                bizTypeName
                bizId
                operationType
                operationTypeName
                operatorId
                operatorName
                operatedAt
                changesJson
                metadataJson
                isEncrypted
                description
                createdAt
                updatedAt
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface SystemOperationLogFiltersType {
    bizType?: number;
    bizId?: string;
    operationType?: number;
    operatorId?: number;
    operatedAtStart?: number;
    operatedAtEnd?: number;
}

export interface SystemOperationLogType {
    id: number;
    bizType: number;
    bizTypeName: string;
    bizId: string;
    operationType: number;
    operationTypeName: string;
    operatorId?: number;
    operatorName?: string;
    operatedAt: number;
    changesJson?: string;
    metadataJson?: string;
    isEncrypted: boolean;
    description?: string;
    createdAt: number;
    updatedAt: number;
}

export interface SystemOperationLogListingResponseType {
    content: SystemOperationLogType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface GetSystemOperationLogListingData {
    getSystemOperationLogListing: SystemOperationLogListingResponseType;
}

export interface GetSystemOperationLogListingVariables {
    filters?: SystemOperationLogFiltersType;
    pageRequest?: {
        page?: number;
        size?: number;
        sortBy?: string;
        sortDirection?: string;
    };
}

